import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_EXPENSES](state, data) {
    state.allExpenses = data
  },
}
